import { useCommonData } from '../../../app/root/ui/CommonDataContext';

export const useLocale = () => useCommonData().locale;
